import React from "react";
import { useTranslation } from "react-i18next";
import { Row } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";
import { IScreenStatus } from "../../app/models/screens";
import PersonalScreenQrButton from "./PersonalScreenQrButton";
import PersonalScreenRegenerateButton from "./PersonalScreenRegenerateButton";

interface IParams {
  screen: IScreenStatus;
}

const PersonalScreenBox: React.FC<IParams> = ({ screen }) => {
  const [t] = useTranslation(["browse_page"], translationHookOptions);

  return (
    <div className="card col-12 customCard">
      <div className="ml-2">
        <Row>
          <div>
            <h5>
              {t("screens_personal_label")}
              <br />
              <b>
                {t("screens_personal_code_label")} {screen.code}
              </b>
            </h5>
          </div>
            <div className="ml-sm-auto">
              <PersonalScreenRegenerateButton screen={screen} />
              <PersonalScreenQrButton screen={screen} />
            </div>
        </Row>
      </div>
    </div>
  );
};

export default PersonalScreenBox;
